<template>
  <i
    class="UIIconComponent"
    :class="icon"
  />
</template>

<script setup lang="ts">
  const props = defineProps<{
    icon: string
  }>()

  const icon = computed(() => {
    return 'icon icon-' + props.icon
  })
</script>

<style lang="scss" scoped>
  .UIIconComponent {
    display: flex;
    align-self: center;
    justify-self: center;
  }
</style>
